/**
 * Full document navigation. The embedded viewers ship their own global
 * stylesheets, so crossing into or out of them must reload the document
 * rather than route in-app. Kept as one function so tests can stub it.
 */
export function openDocument(href: string): void {
  window.location.assign(href);
}
